import React from 'react'
import { reduxForm } from 'redux-form'
import { validation, SubmitButton, Form, Field } from '../helpers/form'

const validateUserEmail = [validation.required, validation.validateEmail]
const validateAccountPassword = [validation.required, validation.minLength(8)]
const validateKeyPassword = [validation.required, validation.minLength(8)]
const validateAccountPasswordConfirm = [
  validation.required,
  validation.validatePasswordConfirm('password')
]
const validateKeyPasswordConfirm = [
  validation.required,
  validation.validatePasswordConfirm('keyPassword')
]

const SignupForm = props => {
  const { handleSubmit, submitting, pending } = props

  return (
    <Form onSubmit={handleSubmit}>
      <Field
        label="E-mail address"
        name="email"
        type="text"
        validate={validateUserEmail}
      />
      <Field
        label="Account password"
        name="password"
        type="password"
        validate={validateAccountPassword}
      />
      <Field
        label="Account password (confirm)"
        name="passwordConfirm"
        type="password"
        placeholder="Confirm"
        validate={validateAccountPasswordConfirm}
      />
      <Field
        label="Private key password"
        name="keyPassword"
        type="password"
        validate={validateKeyPassword}
      />
      <Field
        label="Private key password (confirm)"
        name="keyPasswordConfirm"
        type="password"
        placeholder="Confirm"
        validate={validateKeyPasswordConfirm}
      />
      <SubmitButton
        disabled={submitting || pending}
        text={pending ? 'Creating account…' : 'Create account'}
      />
    </Form>
  )
}

export default reduxForm({ form: 'signup' })(SignupForm)



// WEBPACK FOOTER //
// ./src/components/SignupForm.js